export default __webpack_public_path__ + "static/image2-2f0911e33c59983aadf39aee0d259b09.jpg";